import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { ListVariant, TradeState } from '../../../../../_shared/types/trade';
import convertToCurrency from '../../../../../_shared/utils/convertToCurrency';
import Controls from '../../../../Vdp/BidBox/Controls';
import usePopulateBidContext from '../../../../../_shared/hooks/usePopulateBidContext';
import ReducerConstants from '../../../../../_shared/constants/reducers';
import { BidSource } from '../../../../../_shared/types/auction';
import { useOmpDealerContext } from '../../../../Vdp/OmpDealerProvider';

import { StyledCurrentBid, StyledFooter, StyledEditProxy } from './Styles';

const Footer = ({
  tradeSummary,
  tradeState,
  isAuctionEnded,
  onSelect,
  setBidContext,
  setBidModalOpen
}) => {
  const {
    id: tradeId,
    upcomingProxy,
    hasVehicleHistoryReport,
    auctionSummary
  } = tradeSummary;

  const user = useSelector(
    state => state[ReducerConstants.AUTH]?.user,
    shallowEqual
  );

  // Decides whether or not we should show the edit proxy button on the trade card
  const showEditProxy =
    (tradeState === TradeState.active && auctionSummary?.proxyAmount) ||
    (tradeState === TradeState.upcoming &&
      upcomingProxy?.bidAmount &&
      upcomingProxy?.proxyAmount);

  const getProxyAmount = () => {
    if (tradeState === TradeState.active) {
      return auctionSummary?.proxyAmount > auctionSummary?.maxBid
        ? auctionSummary?.proxyAmount
        : undefined;
    }
    return upcomingProxy?.proxyAmount;
  };

  const { isMultiOrgAndEnabled } = useOmpDealerContext();

  const populateBidContext = usePopulateBidContext({
    auctionSummary,
    bidSource: BidSource.GRID_VIEW,
    isAuctionEnded,
    isMultiOrgAndEnabled,
    setBidContext,
    tradeState,
    tradeSummary,
    upcomingProxy,
    user
  });

  const onProxyButtonClick = () => {
    onSelect(tradeId);
    populateBidContext();
    setBidModalOpen(true);
  };

  return (
    <StyledFooter>
      <StyledCurrentBid>
        {tradeState === TradeState.active &&
          (auctionSummary?.numBids > 0 ? (
            convertToCurrency(auctionSummary?.maxBid)
          ) : (
            <FormattedMessage id="vdp.bid.noBids" />
          ))}
      </StyledCurrentBid>
      {showEditProxy && (
        <StyledEditProxy>
          <Controls
            testId="replace-soon"
            currentBidAmount={
              tradeState === TradeState.upcoming
                ? upcomingProxy?.bidAmount
                : auctionSummary?.maxBid
            }
            currentProxyAmount={getProxyAmount()}
            hasVehicleHistoryReport={hasVehicleHistoryReport}
            onProxyButtonClick={onProxyButtonClick}
            onQuickBidButtonClick={() => {}}
            onBidButtonClick={onProxyButtonClick}
            tradeState={tradeState}
            variant={ListVariant.GRID}
            tradeId={tradeId}
            isAuctionEnded={isAuctionEnded}
            numberOfBids={auctionSummary?.numBids}
            isLoading={false}
            formSubmitting={false}
          />
        </StyledEditProxy>
      )}
    </StyledFooter>
  );
};

export default Footer;
